import React from 'react';
import { useSelector } from 'react-redux';

import HyperLinkComponent from './HyperLinkComponent';
import { FILE_DOWNLOAD, WORKFLOW_STEP } from '../../../constants/Urls';
import { useFormSelector } from '../../../custom-hooks';
import { getToken } from '../../selectors/common.selectors';
import { getEvaluatedHyperLinkExpression } from '../../selectors/runtime.selectors';
import {
  mapTarget,
  preprocessPathname,
  preprocessQueryString,
} from '../../utils/controls/ssHyperLink.utils';

const SSHyperLinkControl = (props) => {
  const {
    id,
    index,
    linkType,
    inTable,
    url,
    isTextViewHyperLink,
    text,
    textToRender,
    isOnline,
  } = props;

  const evaluatedUrl = useFormSelector(getEvaluatedHyperLinkExpression, {
    index,
    id,
    expression: url,
    controlIsInTable: inTable,
    isHyperlinkUrl: true,
  });
  const evaluatedText = useFormSelector(getEvaluatedHyperLinkExpression, {
    id,
    index,
    expression: text,
    controlIsInTable: inTable,
  });
  const token = useSelector(getToken);
  const pathname = preprocessPathname(evaluatedUrl);
  const queryString = preprocessQueryString(evaluatedUrl, pathname, token);
  const target = mapTarget(linkType);

  const isAttachmentLink =
    pathname.includes('Attachmentview') ||
    pathname.includes('AttachmentView') ||
    pathname.includes(FILE_DOWNLOAD.substring(1));

  const isWorkflowStepLink = pathname === WORKFLOW_STEP.substring(1);

  return (
    <HyperLinkComponent
      {...props}
      text={isTextViewHyperLink ? textToRender : evaluatedText}
      queryString={queryString}
      pathname={pathname}
      target={target}
      isAttachmentLink={isAttachmentLink}
      isWorkflowStepLink={isWorkflowStepLink}
      disabled={!isOnline}
    />
  );
};

export default SSHyperLinkControl;
